module.exports = __webpack_public_path__ + "img/emoji-frowning-face.3fbc70ea.svg";